module.exports = __webpack_public_path__ + "static/media/printer.eec9154f.svg";